import axios from 'axios'
import qs from 'qs'
import config from '@/config/index'

const BASE_URL = config.baseUrl
const DEFAULT_MESSAGE = '网络异常，请您稍后重试。请您点击右侧在线咨询，将此截图发给客服，由专业客服7*24小时竭诚为您服务。'

axios.defaults.baseURL = BASE_URL
axios.defaults.withCredentials = process.env.NODE_ENV === 'development'
axios.defaults.paramsSerializer = (params) => {
        return qs.stringify(params, {
            arrayFormat: 'repeat'
        })
    }
    // 500、401、403不用catch
axios.defaults.validateStatus = () => {
        return true
    }
    // IE9 get请求有缓存问题
axios.interceptors.request.use(config => {
    if (config.method === 'get') {
        if (config.params) {
            config.params.v = new Date().getTime()
        } else {
            if (config.url.indexOf('?') > -1) {
                config.url += '&v=' + new Date().getTime()
            } else {
                config.url += '?v=' + new Date().getTime()
            }
        }
    }

    let str = ''
    let hasQuery = config.url.indexOf('?') > -1

    let pathStr = ''
    let queryStrArr = []
    let queryStr = ''
    let bodyStr = ''

    if (hasQuery) {
        pathStr = config.url.substring(0, config.url.indexOf('?'))
            // url?之后的
        queryStrArr = config.url.substring(config.url.indexOf('?') + 1).split('&')
    } else {
        pathStr = config.url
    }
    // 处理
    pathStr = pathStr.replace(/^\/ff-[a-zA-Z0-9]{2,4}/, '')
        // console.log('path->' + pathStr);

    // query
    if (config.params) {
        let keys = Object.keys(config.params)
        for (let key of keys) {
            if (!Array.isArray(config.params[key])) {
                if (config.params[key] !== undefined) {
                    let v = config.params[key] || config.params[key] === false || config.params[key] === 0 ? config.params[key] : ''
                    queryStrArr.push(key + '=' + v)
                }
            } else {
                for (let value of config.params[key]) {
                    if (config.params[key] !== undefined && value !== undefined) {
                        let v = value || value === false || value === 0 ? value : ''
                        queryStrArr.push(key + '=' + v)
                    }
                }
            }
        }
        // Object.assign(queryObj, config.params)
    }

    if (queryStrArr.length > 0) {
        queryStr = queryStrArr.sort().join('&')
    }

    // data
    if (config.data && Object.keys(config.data).length > 0) {
        // let bodyKeys = Object.keys(config.data).sort()
        // for (let key of bodyKeys) {
        //   if(config.data[key] !== undefined) {
        //     bodyStr += '&' + key + '=' + config.data[key]
        //   }
        // }
        // bodyStr = bodyStr.substring(1)
        bodyStr = JSON.stringify(config.data)
    }
    str = pathStr + queryStr + bodyStr

    config.headers['x-vrandom'] = md5(str)

    // 防止中文乱码
    config.url = encodeURI(config.url)
    return config
})

let ajax = {
    get(url, param) {
        let params = {
            url: url,
            method: 'get'
        }
        if (param) {
            Object.assign(params, param)
        }
        return this.req(params)
    },
    post(url, data) {
        let params = {
            url: url,
            method: 'post'
        }
        if (data) {
            params.data = data
        }
        return this.req(params)
    },
    put(url, data) {
        let params = {
            url: url,
            method: 'put'
        }
        if (data) {
            params.data = data
        }
        return this.req(params)
    },
    delete(url, param) {
        let params = {
            url: url,
            method: 'delete'
        }
        if (param) {
            Object.assign(params, param)
        }
        return this.req(params)
    },
    req(params) {
        return new Promise((resolve, reject) => {
            return axios.request(params).then(response => {
                let data = response.data
                let status = response.status
                if (status !== 200) {
                        // 重新登录
                    if (status === 401 || status === 403) {
                        if(window.top.location.href.indexOf('?redirect=') < 0) {
                          window.top.location = '/finance/login?redirect=' + window.top.location.href
                        }
                        return
                    } else {
                        data.message = DEFAULT_MESSAGE
                    }
                } else {
                    if (!data.message || data.code === '99999999') {
                        data.message = DEFAULT_MESSAGE
                    }
                }
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    }
}

export default ajax
